<template>
  <div class="arsenal__filters">
    <div class="arsenal__filters__result">
      <div class="filter-label">
        <span>{{ $t("arsenal.filters.label") }}:</span>
        {{ $t(`arsenal.filters.${activeFilter}`) }}
      </div>
      <div class="filter-change">
        {{ $t("arsenal.filters.change") }}
        <i class="icon icon-arrow-small"></i>
      </div>
    </div>

    <div class="arsenal__filters__list">
      <span
        v-for="filter in filters"
        :key="filter"
        class="arsenal__filters__item gtm-filter-weapontype"
        @click="changeFilter(filter)"
      >
        {{ $t(`arsenal.filters.${filter}`) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArsenalFilters",

  props: {
    activeFilter: String,
  },

  data() {
    return {
      filters: ["all", "weapon", "skin", "appearance"],
    };
  },

  methods: {
    changeFilter(filter) {
      this.$emit("changeFilter", filter);
    },
  },
};
</script>
